import history from 'yola-editor/src/js/browser-history';

const handlePublishRoute = () => {
  const { pathname, search } = window.location;
  const isPublish = pathname.includes('/publish');

  if (!isPublish) {
    return { isPublish: false, domain: null, isThirdPartyDomain: false };
  }

  const searchParams = new URLSearchParams(search);
  const domain = searchParams.get('domain');
  const isThirdPartyDomain = searchParams.has('is_third_party_domain');

  history.replace('/');

  return { isPublish, domain, isThirdPartyDomain };
};

export default handlePublishRoute;
